<template>
  <v-container>
    <v-layout row fluid>
      <v-flex xs12 sm8 offset-sm2>
        <v-card>
          <v-toolbar class="primary">
            <v-toolbar-title class="white--text">Total Ventas</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
               <v-flex sm4 xs12>
                <v-dialog
                    persistent
                    v-model="menu"
                    lazy
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      label="Desde"
                      v-model="fechainicio"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="fechainicio" scrollable>
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
              </v-flex>
               <v-flex sm4 xs12>
                <v-dialog
                    persistent
                    v-model="menu2"
                    lazy
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      label="Hasta"
                      v-model="fechafin"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>

                    <v-date-picker v-model="fechafin" scrollable >
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
              </v-flex>
               <v-flex sm2 xs12>
                  <v-btn flat @click="mostrar" class="green--text">
                    Mostrar<v-icon>find_in_page</v-icon>
                  </v-btn>
               </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <table class="table">
            <thead>
            <tr>
              <th><b>Lista</b></th>
              <th><b>Total:</b></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="dato in resultado">
                <td style="text-align: center">{{dato.nombrelista}}</td>
                <td style="text-align: center">{{parseFloat(dato.total).toLocaleString('es-GT')}}</td>
              </tr>
            </tbody>
          </table>
          </v-card-text>

        </v-card>
      </v-flex>
    </v-layout>
    <v-layout>
    </v-layout>
  </v-container>
</template>

<script>
  import {reporte} from '../plugins/urlsbackend'

  export default {
    data () {
      return {
        menu: false,
        menu2: false,
        fechainicio: '',
        fechafin: '',
        datos: {}
      }
    },
    methods: {
      mostrar: function () {
        this.$http.get(reporte,
          {params: {
            fechaminima: this.fechainicio,
            fechamaxima: this.fechafin
          },
            headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}
              ).then(response => {
                this.datos = response.body.results
              })
      }
    },
    computed: {
      resultado: function () {
        return this.datos
      },
      total: function () {
        let tot = 0
        for (var result in this.datos) {
          tot = tot + parseFloat(this.datos[result].total)
        }
        let total = tot.toLocaleString('es-GT')
        return total
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ReporteVentas.vue?2a71e97f